"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddBookmarkIcon = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const AddBookmarkIcon = (_a) => {
    var { color } = _a, props = __rest(_a, ["color"]);
    return ((0, jsx_runtime_1.jsxs)("svg", Object.assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M9 3C8.5 3 7 4 7 5V20L12.5 16L18 20V5C18 4 16.5 3 16 3H9Z", stroke: color || '#2C2C2C', strokeWidth: "2" }), (0, jsx_runtime_1.jsx)("path", { d: "M11.5801 13V10.46H9.5V8.78003H11.5801V6.5H13.3201V8.78003H15.5001V10.46H13.3201V13H11.5801Z", fill: color || '#2C2C2C' })] })));
};
exports.AddBookmarkIcon = AddBookmarkIcon;
//# sourceMappingURL=add_bookmark_icon.js.map